


<div *ngIf="ehrId" #printSection id="print-section">
    <form-renderer #scheda  *ngIf="form "
                    [compositionId]="compositionId" 
                    [context]="context"
                    [credentials]="credentials"
                    [formEnvironment]="betterEnvirorment"
                    [formMetadata]="form"
                    [resourceUrl]="resourceUrl"
                    id="form-renderer"
        >
        </form-renderer>
        <div class="row">
            <button class="btn btn-success" (click)="onSubmit()" *ngIf="cambia && compositionId">Modifica</button>
            <button class="btn btn-success" (click)="onSave()" *ngIf="cambia && !compositionId">Modifica</button>

        </div>
</div>